import { StandardEvents } from '@shopify/events';

/**
 * <amq-lieferzeit> (blocks/amq_lieferzeit.liquid): keeps the delivery time in step with the selected
 * variant. The range comes from metaobjects the variant JSON doesn't carry, so the element copies
 * itself from the section HTML the theme re-renders for the new variant (detail.html), the same
 * source sticky-add-to-cart.js uses. A combined-listing switch replaces the section anyway.
 */
class AmqLieferzeit extends HTMLElement {
  /** @type {Element | null} */
  #target = null;

  connectedCallback() {
    this.#target = this.closest('[id*="ProductInformation-"], [id*="QuickAdd-"]');
    this.#target?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    this.#target?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
    this.#target = null;
  }

  /**
   * @param {import('@shopify/events').ProductSelectEvent} event
   */
  #handleProductSelect = (event) => {
    if (event.target instanceof Element && event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        const fresh = detail?.html?.querySelector?.(`#${CSS.escape(this.id)}`);
        if (!fresh) return;
        this.hidden = fresh.hasAttribute('hidden');
        this.innerHTML = fresh.innerHTML;
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[amq-lieferzeit] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('amq-lieferzeit')) {
  customElements.define('amq-lieferzeit', AmqLieferzeit);
}
